import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { NoteDialogComponent } from './note-dialog.component';

import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { NoteAttachmentBufferModule } from '../note-attachment-buffer/note-attachment-buffer.module';
import { NoteAttachmentsModule } from '../note-attachments/note-attachment.module';
import { TemplateModule } from '../template/template.module';
@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        // kendo
        ButtonsModule,
        ChartModule,
        DateInputsModule,
        DropDownButtonModule,
        DropDownsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        DialogsModule,

        TemplateModule,
        NoteAttachmentsModule,
        NoteAttachmentBufferModule,
    ],
    declarations: [
        NoteDialogComponent,
    ],
    exports: [
        NoteDialogComponent,
    ]
})
export class NoteDialogModule { }
